import React, { memo } from 'react';
import { NodeProps } from '@xyflow/react';
import { useSelector } from 'react-redux';
import BaseNode from '../BaseNode';
import { useTranslation } from 'react-i18next';
import { typeLabelOf } from '../../nodeCatalog';
import { useConnectionGone } from '../useConnectionGone';

/** 실행 분류 노드 3종 — 실행(다른 워크플로), 외부명령어(서버 셸), SQL실행(DB 스크립트). 문자열 속성의 ${변수} 는 실행 시 치환된다.
 *  유형 이름은 typeLabelOf(type) (nodeCatalog) — 번역 키 한 곳에서 정한다 */

const ICONS: Record<string, React.ReactNode> = {
  runWorkflow: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
  ),
  shellCommand: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M7 9l3 3-3 3" /><path d="M12 15h5" /></svg>
  ),
  sqlScript: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5" /><path d="M9 11l-2 2 2 2M15 11l2 2-2 2" /></svg>
  ),
};

const ExecNode: React.FC<NodeProps<any>> = ({ data, selected, id, type, ...props }) => {
  const { t } = useTranslation();
  const workflows = useSelector((s: any) => s.project?.workflows || []);
  const cfg = data?.config || {};
  const ty = String(type);
  const connGone = useConnectionGone(ty === 'sqlScript' ? cfg.connection : undefined);
  // 노드 아래 한 줄 — 무엇을 실행하는지(워크플로명·명령·커넥션)가 먼저다. 유형 이름은 노드 안에 이미 있다
  let subtitle = '';
  if (ty === 'runWorkflow') {
    const wf = workflows.find((w: any) => w.id === cfg.workflowId);
    subtitle = wf ? wf.name : (cfg.workflowId || t('workflow:exec.noWorkflow'));
  } else if (ty === 'shellCommand') {
    subtitle = cfg.mode === 'script'
      ? (cfg.script ? `📜 ${cfg.script}` : t('workflow:exec.noScript'))
      : (cfg.command || '').split('\n')[0] || t('workflow:exec.noCommand');
  } else if (ty === 'sqlScript') {
    subtitle = cfg.connection || t('workflow:exec.noConnection');
  }
  // 파라미터 개수는 노드 아래 한 줄에서 자리를 많이 차지해 붙이지 않는다 — 속성 패널에서 본다
  return <BaseNode id={id} data={data} selected={selected} type={type} icon={ICONS[ty]} label={data?.label || typeLabelOf(ty)} subtitle={subtitle} warning={connGone} {...props} />;
};

export default memo(ExecNode);
